module.exports = __webpack_public_path__ + "img/password_reset.5911f723.svg";